import _flowRight from 'lodash/flowRight';
import { getPointsBalance } from '@homeservices/api-kit/workorder/points';

import {
  withRequestLifecycle,
  REQUEST_LIFECYCLE,
} from '@/utils/request-lifecycle';

const MUTATION_KEY = 'patchPointsBalance';

const emptyObject = {};

export default {
  namespaced: true,
  state: {
    current: {
      status: REQUEST_LIFECYCLE.UNINITIALIZED,
      error: null,
      result: emptyObject,
    },
  },
  getters: {
    currentPointsBalanceMeta: (state) => {
      const { result, ...meta } = state.current;

      return meta;
    },
    currentRawPointsBalance: state => state.current.result,
  },
  actions: {
    fetchPointsBalance: _flowRight(withRequestLifecycle(MUTATION_KEY))(
      async (context, { injected: { performFulfillment } }) => {
        const { data: result } = await getPointsBalance();

        return performFulfillment({ result });
      }
    ),
  },
  mutations: {
    [MUTATION_KEY] (state, payload) {
      state.current = {
        ...state.current,
        ...payload,
      };
    },
  },
};
